import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MessageCircleIcon, InstagramIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
import { CONTACTO, VCARS_LOGO } from '../data/brand';
const nav = [{
  label: 'Catálogo',
  to: '/catalogo'
}, {
  label: 'Oportunidades',
  to: '/catalogo?oportunidad=1'
}, {
  label: 'Financiación',
  to: '/financiacion'
}, {
  label: 'Vendé tu auto',
  to: '/vender-mi-auto'
}, {
  label: 'Permutas',
  to: '/permutas'
}, {
  label: 'Contacto',
  to: '/contacto'
}];
const accesos = [{
  label: `WhatsApp ${CONTACTO.ventasNombre}`,
  detail: `${CONTACTO.ventasTelefono} · Ventas`,
  href: whatsappLink(GENERAL_WA_MESSAGE, CONTACTO.ventasWhatsapp),
  icon: MessageCircleIcon,
  tone: 'text-[#25c264]',
  external: true
}, {
  label: 'WhatsApp Administración',
  detail: `${CONTACTO.adminTelefono} · Administración general`,
  href: whatsappLink(GENERAL_WA_MESSAGE, CONTACTO.adminWhatsapp),
  icon: PhoneIcon,
  tone: 'text-[#25c264]',
  external: true
}, {
  label: 'Email',
  detail: CONTACTO.email,
  href: `mailto:${CONTACTO.email}`,
  icon: MailIcon,
  tone: 'text-neon',
  external: false
}, {
  label: 'Instagram',
  detail: CONTACTO.instagramUsuario,
  href: CONTACTO.instagram,
  icon: InstagramIcon,
  tone: 'text-neon',
  external: true
}];
export function Footer() {
  return <footer className="border-t border-neon/25 bg-surface" data-id="element-76" data-mp="33xd9vvh5urg">
      <div className="mx-auto w-full max-w-7xl px-5 py-14 md:px-8 md:py-16" data-id="element-77" data-mp="33e5v93gaoro">
        <div className="grid gap-10 lg:grid-cols-[1.15fr_0.8fr_1.25fr] lg:gap-14" data-id="element-78" data-mp="hrs6dddea152">
          <div data-id="element-79" data-mp="ct77pidsjpiq">
            <div className="flex items-center gap-2.5" data-id="element-80" data-mp="cus1v6w716g2">
              <img src={VCARS_LOGO} alt="Logo de VCARS" className="h-11 w-11 rounded-full object-cover ring-1 ring-neon/40" data-id="element-81" data-mp="qthy6kb6v23d" />
              <span className="text-lg font-black tracking-[0.18em] text-neon-soft" data-id="element-82" data-mp="mq3g7o3owbna">
                VCARS
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-mist" data-id="element-83" data-mp="ytekkiej0et9">
              Usados seleccionados, 0KM, financiación, permutas y gestión de ventas
              particulares.
            </p>
            <p className="mt-4 flex items-start gap-2 text-sm text-mist" data-id="element-84" data-mp="18l2eqr2gw9yf">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-neon" aria-hidden="true" data-id="element-85" data-mp="1clumffvoy6sl" />
              {CONTACTO.ubicacion}
            </p>
          </div>

          <nav aria-label="Enlaces del sitio" data-id="element-86" data-mp="1mj8v2tbdhrac">
            <h3 className="text-[12px] font-bold uppercase tracking-wider text-white" data-id="element-87" data-mp="1mkjvqk9iuix8">
              Secciones
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-88" data-mp="3ob549wa2ip1y">
              {nav.map(l => <li key={l.label} data-id="element-89" data-mp="3od857bcre2lg">
                  <Link to={l.to} className="text-sm text-mist transition-colors duration-150 ease-smooth hover:text-white" data-id="element-90" data-mp="3t9q4hvpbl8qe">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-91" data-mp="21ma637p8z1vq">
            <h3 className="text-[12px] font-bold uppercase tracking-wider text-white" data-id="element-92" data-mp="21nv3d52y4yxa">
              Contacto VCARS
            </h3>
            <ul className="mt-4 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-93" data-mp="1wlm8g36ijmsj">
              {accesos.map(({
              label,
              detail,
              href,
              icon: Icon,
              tone,
              external
            }) => <li key={label} data-id="element-94" data-mp="2pdfljlr9zs5i">
                  <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="flex items-center gap-3 rounded-xl border border-line bg-surface2/40 px-4 py-3 transition-[border-color,box-shadow] duration-150 ease-smooth hover:border-neon/60 hover:shadow-[0_0_24px_-14px_rgba(31,123,255,0.95)]" data-id="element-95" data-mp="2pa9yec27j0cf">
                    <Icon className={`h-4 w-4 shrink-0 ${tone}`} aria-hidden="true" data-id="element-96" data-mp="2rvhe9iiy615f" />
                    <span className="min-w-0" data-id="element-97" data-mp="2wmzicfg9ohum">
                      <span className="block text-[13.5px] font-semibold text-white" data-id="element-98" data-mp="2wnr1gqsogn40">
                        {label}
                      </span>
                      <span className="block truncate text-[12.5px] text-mist" data-id="element-99" data-mp="2ntmgup4507wx">
                        {detail}
                      </span>
                    </span>
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-line/70" data-id="element-100" data-mp="31lj68lef83pm">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-2 px-5 py-6 text-[13px] text-mist md:flex-row md:items-center md:justify-between md:px-8" data-id="element-101" data-mp="31kr7x2tfvrvn">
          <p data-id="element-102" data-mp="1q6nh25i5ejut">© {new Date().getFullYear()} VCARS. Todos los derechos reservados.</p>
          <p data-id="element-103" data-mp="1q8qfndxd9lb5">Vendé, comprá o financiá tu próximo auto con asesoramiento profesional.</p>
        </div>
      </div>
    </footer>;
}